import { collections } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function CollectionsSection() {
  return (
    <section id="collections" className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <SectionHeading
          index="03"
          title="平台大全与主题合集"
          desc="按更新节奏与使用场景分成若干合辑，每个合辑把同类平台归到一起，标题优先、配图从简，先看清单再决定点开哪一个。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item) => (
            <article
              key={item.title}
              className="group flex cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50/60"
            >
              <div className="h-20 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title}合集封面`}
                  title={`${item.title} 黑料平台推荐合集`}
                  className="h-full w-full object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <span className="shrink-0 whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                    {item.count} 条
                  </span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary-700">
                  进入合集
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}